import { useAppData } from "./App.tsx";
import { useSignal } from "@preact/signals";
import { GageLogo } from "./GageLogo.tsx";
import { useEffect } from "preact/hooks";
import { isBrowser } from "../app/client-utils.ts";

export function Login() {
  const _appData = useAppData();
  const error = useSignal('');
  const loading = useSignal(false);
  const email = useSignal("");

  useEffect(() => {
    if (!isBrowser) return;
    const searchParams = new URLSearchParams(location.search);
    email.value = searchParams.get("email") || '';
  }, []);

  async function loginUser(username: string, password: string) {
    const res = await fetch('/api/login', {
      method: 'POST',
      body: JSON.stringify({ username, password })
    });

    if (!res.ok) throw new Error(await res.text());

    location.reload();
  }

  async function onSubmit(e: SubmitEvent) {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);

    try {
      error.value = '';
      loading.value = true;
      await loginUser(formData.get('username') as string, formData.get('password') as string);
    } catch (e) {
      console.error(e);
      error.value = e.message;
    }
    finally {
      form["password"].value = '';
      // form.reset();
      loading.value = false;
    }
  }

  return <div class="login">
    <div className="login">
      <h2>
        <GageLogo /> Ignite.
      </h2>
      <h1>Login</h1>
      <form onSubmit={onSubmit}>
        <input name="username" type="email" placeholder="Email" required autoComplete="off" defaultValue={email.value} autofocus />
        <input name="password" type="password" placeholder="Password" required autoComplete="off" />
        <button disabled={loading.value} type="submit">Login</button>
        {error.value && <div class="error">{error.value}</div>}
      </form>
    </div>
  </div>
}